import '../App.css';

import {Fragment, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {MenuAlt2Icon, XIcon} from '@heroicons/react/outline'
import Lottie from "lottie-react";
import MemegorBlk from "../lottie-loop/mg-icon-loop-black.json";

export default function MobileNavigation() {
    const [sidebarOpen, setSidebarOpen] = useState(false)

    return (<> < div className="z-50" > <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 flex z-40" onClose={setSidebarOpen}>
            <Transition.Child
                as={Fragment}
                enter="transition-opacity ease-linear duration-[1200ms]"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity ease-linear duration-[1200ms]"
                leaveFrom="opacity-100"
                leaveTo="opacity-0">
                <Dialog.Overlay
                    className="fixed inset-0 backdrop-blur-xl bg-gray-600 bg-opacity-75"/>
            </Transition.Child>
            <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-[1200ms] transform"
                enterFrom="-translate-y-full"
                enterTo="translate-y-0"
                leave="transition ease-in-out duration-[1200ms] transform"
                leaveFrom="translate-y-0"
                leaveTo="-translate-y-full">
                <div className="relative flex-1 flex flex-col w-full md:h-4/5 pt-16 bg-white">
                <div className="flex justify-between flex-col">
                    <div className=" w-full px-10 py-10">
                        <Lottie animationData={MemegorBlk} loop="true" className="w-32 h-32 " />
                    </div>
                </div>
                    <Transition.Child
                        as={Fragment}
                        enter="transition ease-in-out duration-[1200ms] transform"
                        enterFrom="-translate-y-full"
                        enterTo="translate-y-0"
                        leave="transition ease-in-out duration-[1200ms] transform"
                        leaveFrom="translate-y-0"
                        leaveTo="-translate-y-full">
                        <div className="w-full h-4/5 bg-white shadow-md z-10 ">
                            <div className="flex flex-col h-full inset-y-0">
                                <div className="flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white">
                                    <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
                                        <div className="mt-5 flex-1 px-2 bg-white space-y-1">
                                            <div className="flex justify-between md:flex-row-reverse flex-col">
                                            <div className="md:pr-40 px-10">
                                                
                                                <div className="font-objectsansBold text-md md:h-10 h-12">menu</div>
                                                
                                                <a href="/" >
                                                    <div className="font-objectsansRegular text-xl py-2">Home</div>
                                                </a>
                                                <a href="/merch">
                                                    <div className="font-objectsansRegular text-xl py-2">Merch List</div>
                                                </a>
                                                <a href="/find">
                                                    <div className="font-objectsansRegular text-xl py-2">Find Us</div>
                                                </a>
                                                <a href="/about">
                                                <div className="font-objectsansRegular text-xl py-2">About Us</div>
                                                </a>
                                            </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Transition.Child>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-in-out duration-[1200ms]"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in-out duration-[1200ms]"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0">
                        <div className="absolute top-0 right-0 -mr-12 pt-2">
                            <button
                                type="button"
                                className="absolute top-0 h-20 w-20 right-12 px-4 text-gray-900 "
                                onClick={() => setSidebarOpen(false)}>
                                <span className="sr-only">Close sidebar</span>
                                <XIcon className="h-12 w-12 text-black" aria-hidden="true"/>
                            </button>
                        </div>
                    </Transition.Child>
                </div>
            </Transition.Child>
            {/*<div className="flex-shrink-0 w-20" aria-hidden="true">
               Dummy element to force sidebar to shrink to fit close icon
            </div>*/
            }
        </Dialog>
    </Transition.Root>
    <div className="flex flex-col flex-1">
        <div
            className="fixed inset-0 z-10 flex-shrink-0 flex h-20 ">
            <button
                type="button"
                className="absolute top-0 h-20 w-20 right-0 px-4 text-gray-900 mix-blend-difference "
                onClick={() => setSidebarOpen(true)}>
                <span className="sr-only">Open sidebar</span>
                <MenuAlt2Icon className="h-12 w-12" aria-hidden="true"/>
            </button>
        </div>
    </div>
</div> < />
    )
}